<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button :returnUrl="returnUrl"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4 v-if="organization != null">
            <u>Φορέας : {{ organization.Description }}</u>
          </h4>
        </div>
      </div>
    </div>

    <div
      class="row"
      style="padding-top: 20px; padding-left: 20px"
      v-if="organization != null"
    >
      <form class="forms-style">
        <div class="row">
          <div class="col-md-6">
            <div class="panel-heading">Γενικά στοιχεία</div>
            <div class="panel panel-primary">
              <div class="panel-body">
                <div class="form-group">
                  <label for="id" class="col-sm-3 control-label">Κωδικός</label>
                  <input
                    type="text"
                    class="form-field"
                    id="id"
                    v-model="organization.Code"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="id" class="col-sm-3 control-label"
                    >Περιγραφή</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Description"
                    v-model="organization.Description"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="id" class="col-sm-3 control-label">ΑΦΜ</label>
                  <input
                    type="text"
                    class="form-field"
                    id="Afm"
                    v-model="organization.Afm"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="OrganizationType" class="col-sm-3 control-label"
                    >Tύπος</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="OrganizationType"
                    v-model="organization.OrganizationTypeDto.Description"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="IsActive" class="col-sm-3 control-label"
                    >Ενεργός</label
                  >
                  <input
                    type="checkbox"
                    id="IsActive"
                    v-model="organization.IsActive"
                    disabled
                  />
                </div>
              </div>
            </div>

            <div class="panel-heading">Επικοινωνία</div>
            <div class="panel panel-primary">
              <div class="panel-body">
                <div class="form-group">
                  <label for="ContactPerson" class="col-sm-3 control-label"
                    >Αρμόδιος</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="ContactPerson"
                    v-model="organization.ContactPerson"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="Municipality" class="col-sm-3 control-label"
                    >Δήμος</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Municipality"
                    v-model="organization.MunicipalityDto.Description"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="Address" class="col-sm-3 control-label"
                    >Διεύθυνση</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Address"
                    v-model="organization.StreetName"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="StreetNumber" class="col-sm-3 control-label"
                    >Αριθμός</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="StreetNumber"
                    v-model="organization.StreetNum"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="ZipCode" class="col-sm-3 control-label"
                    >Ταχ.Κώδικας</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="ZipCode"
                    v-model="organization.ZipCode"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="Phone" class="col-sm-3 control-label"
                    >Τηλέφωνο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Phone"
                    v-model="organization.PhoneNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="Fax" class="col-sm-3 control-label">Fax</label>
                  <input
                    type="text"
                    class="form-field"
                    id="Fax"
                    v-model="organization.FaxNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="Email" class="col-sm-3 control-label"
                    >Email</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="Email"
                    v-model="organization.Email"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="panel-heading">Nόμιμος εκπρόσωπος</div>
            <div class="panel panel-primary">
              <div class="panel-body">
                <div class="form-group">
                  <label for="LrAfm" class="col-sm-3 control-label">ΑΦΜ</label>
                  <input
                    type="text"
                    class="form-field"
                    id="LrAfm"
                    v-model="organization.LrAfm"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrName" class="col-sm-3 control-label"
                    >Ονοματεπώνυμο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrName"
                    v-model="LrName"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrFatherName" class="col-sm-3 control-label"
                    >Πατρώνυμο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrFatherName"
                    v-model="organization.LrFatherName"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrMotherName" class="col-sm-3 control-label"
                    >Μητρώνυμο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrMotherName"
                    v-model="organization.LrMotherName"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrBirthDate" class="col-sm-3 control-label"
                    >Ημερ.Γέννησης</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrBirthDate"
                    :value="organization.LrBirthDate | formatDate"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrCity" class="col-sm-3 control-label"
                    >Πόλη</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrCity"
                    v-model="organization.LrCity"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrStreetName" class="col-sm-3 control-label"
                    >Διεύθυνση</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrStreetName"
                    v-model="organization.LrStreetName"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrStreetNum" class="col-sm-3 control-label"
                    >Αριθμός</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrStreetNum"
                    v-model="organization.LrStreetNum"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrZipCode" class="col-sm-3 control-label"
                    >Ταχ.Κώδικας</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrZipCode"
                    v-model="organization.LrZipCode"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrPhoneNumber" class="col-sm-3 control-label"
                    >Τηλέφωνο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrPhoneNumber"
                    v-model="organization.LrPhoneNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrPhoneNumber" class="col-sm-3 control-label"
                    >Τηλέφωνο</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrPhoneNumber"
                    v-model="organization.LrPhoneNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrFaxNumber" class="col-sm-3 control-label"
                    >Fax</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrFaxNumber"
                    v-model="organization.LrFaxNumber"
                    readonly
                  />
                </div>

                <div class="form-group">
                  <label for="LrEmail" class="col-sm-3 control-label"
                    >Email</label
                  >
                  <input
                    type="text"
                    class="form-field"
                    id="LrEmail"
                    v-model="organization.LrEmail"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";

import BackButton from "../../components/shared/backButton";

export default {
  props: ["oId"],
  components: {
    BackButton,
  },
  data() {
    return {
      organization: null,
    };
  },
  computed: {
    LrName() {
      return (
        (this.organization.LrLastName != null
          ? this.organization.LrLastName
          : "") +
        " " +
        (this.organization.LrFirstName != null
          ? this.organization.LrFirstName
          : "")
      );
    },
    returnUrl() {
      if (this.$store.getters.isRepresentative || this.$store.getters.isUser)
        return "/home";
      else return "/organizations";
    },
  },
  methods: {},

  async mounted() {
    const res = await mainService.get(
      `/Organizations/GetOrganizationById?id=${this.oId}`
    );
    this.organization = res.data;
  },
};
</script>

<style lang="scss" scoped>
.forms-style label {
  width: 150px;
}
input[type="checkbox"] {
  margin: 1px 0 0 5px;
  width: 40px;
  height: 40px;
}
</style>